import { authTypes, loginTypes, userTypes, impersonateTypes } from './types';

const authActions = {
  impersonateRollbackSuccess: payload=>({
    type: impersonateTypes.ROLLBACK_SUCCESS,
    payload
  }),
  impersonateRollback: () => ({
    type: impersonateTypes.ROLLBACK,
  }),
  impersonateRequest: payload => ({
    type: impersonateTypes.REQUEST,
    payload
  }),
  impersonateSuccess: payload => ({
    type: impersonateTypes.SUCCESS,
    payload
  }),
  impersonateFailed: errorMessage => ({
    type: impersonateTypes.FAILED,
    payload: errorMessage
  }),
  impersonatePermissionsError: payload => ({
    type: impersonateTypes.PERMISSIONS_ERROR,
    payload
  }),

  authResetError: () => ({
    type: authTypes.RESET_ERROR
  }),
  authResetResultMessage: () => ({
    type: authTypes.RESET_RESULT_MESSAGE
  }),
  
  loginRequest: payload => ({
    type: loginTypes.REQUEST,
    payload
  }),
  loginSuccess: payload => ({
    type: loginTypes.SUCCESS,
    payload
  }),
  loginFailed: errorMessage => ({
    type: loginTypes.FAILED,
    payload: errorMessage
  }),
  logout: (payload: string) => ({
    type: loginTypes.LOGOUT,
    payload
  }),
  logoutSuccess: (payload: string) => ({
    type: loginTypes.LOGOUT_SUCCESS,
    payload
  }),
  logoutFailed: payload => ({
    type: loginTypes.LOGOUT_FAILED,
    payload
  }),
  setPasswordSecurity: (isPasswordSecure) => ({
    type: authTypes.SET_PASSWORD_SECURITY,
    payload: isPasswordSecure
  }),
  acceptTermsRequest: payload => ({
    type: userTypes.ACCEPT_TERMS_REQUEST,
    payload
  }),
  acceptTermsSuccess: () => ({
    type: userTypes.ACCEPT_TERMS_SUCCESS
  }),
  acceptTermsFailed: () => ({
    type: userTypes.ACCEPT_TERMS_FAILED
  }),

  changePasswordRequest: payload => ({
    type: userTypes.CHANGE_PASSWORD_REQUEST,
    payload
  }),
  changePasswordSuccess: () => ({
    type: userTypes.CHANGE_PASSWORD_SUCCESS
  }),
  changePasswordFailed: payload => ({
    type: userTypes.CHANGE_PASSWORD_FAILED,
    payload
  }),

  resetPasswordRequest: payload => ({
    type: userTypes.RESET_PASSWORD_REQUEST,
    payload
  }),
  resetPasswordSuccess: () => ({
    type: userTypes.RESET_PASSWORD_SUCCESS
  }),
  resetPasswordFailed: payload => ({
    type: userTypes.RESET_PASSWORD_FAILED,
    payload
  })
};

export default authActions;
